import { render, staticRenderFns } from "./wishlist.vue?vue&type=template&id=4d7d8940&"
import script from "./wishlist.vue?vue&type=script&lang=ts&"
export * from "./wishlist.vue?vue&type=script&lang=ts&"
import style0 from "./wishlist.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DialogLoading: require('/var/www/linza-front/linza-front-20251107075108/components/common/DialogLoading.vue').default})
